import { message } from "antd";
import { FC, useState } from "react";
import CollapseCard from "../../../components/collapseCard";
import DocumentsUpload from "../../../components/documentsUpload";
import LeasingStore from "../../../contexts/leasingStore";
import _t from "../../../lang/translate";
import { downloadAllFiles, leasingFileEndpoint } from "../../../services/leasingService";
import { isAxiosError } from "../../../utilities/typeGuard";

const LeasingAttachmentsCard: FC = () => {
  const { leasingCase, setLeasingCase, isAdmin } = LeasingStore.useContainer();
  const [loading, setLoading] = useState<boolean>(false);

  const handleDownloadAll = async () => {
    try {
      setLoading(true);
      const { data } = await downloadAllFiles(leasingCase.id);
      if (data?.url) window.open(data.url, "_blank");
    } catch (error) {
      const errorMessage = isAxiosError(error) ? error.response?.data?.message : null;
      message.error(errorMessage || _t("msg.unknown_error"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <CollapseCard title={_t("attachments")} loading={loading}>
      <DocumentsUpload
        onDownloadAll={handleDownloadAll}
        fileList={leasingCase.files || []}
        canLockFiles={isAdmin}
        onChange={({ fileList }) => {
          setLeasingCase({ ...leasingCase, files: fileList });
        }}
        action={leasingFileEndpoint(leasingCase?.id)}
      />
    </CollapseCard>
  );
};

export default LeasingAttachmentsCard;
